import { useState } from "react";
import { Card } from "@mui/material";
import { server } from "../../server";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function AddNewShop() {
  const navigate = useNavigate();
  const [shopName, setShopName] = useState("");
  const [shopCode, setShopCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = {
        shopName,
        shopCode,
      };

      const { data } = await axios.post(`${server}/shop/new`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("bvmToken")}`,
        },
      });

      toast.success(data?.message || "Shop added successfully!");
      // navigate("../somePath"); // Uncomment or adjust if redirection is needed
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      console.error("Error adding shop:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center w-full">
      <Card
        sx={{
          p: { xs: 3, md: 5 },
          width: "100%",
          maxWidth: 500,
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
        }}
        className="bg-white"
      >
        <div className="text-center mb-8">
          <h1 className="text-2xl md:text-3xl font-bold text-slate-800 tracking-tight">
            Add New Shop
          </h1>
          <p className="text-slate-500 mt-2 text-sm md:text-base">
            Enter the details to register a new shop
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">
              Shop Name
            </label>
            <input
              type="text"
              placeholder="e.g. Downtown Electronics"
              value={shopName}
              onChange={(e) => setShopName(e.target.value)}
              className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg text-slate-800 placeholder-slate-400 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">
              Shop Code
            </label>
            <input
              type="text"
              placeholder="e.g. SH-001"
              value={shopCode}
              onChange={(e) => setShopCode(e.target.value)}
              className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg text-slate-800 placeholder-slate-400 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3.5 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 ${
              loading ? "opacity-70 cursor-not-allowed" : "active:transform active:scale-[0.98]"
            }`}
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Processing...
              </span>
            ) : (
              "Create Shop"
            )}
          </button>
        </form>
      </Card>
    </div>
  );
}
